import { Injectable } from '@angular/core';
import { UUID } from '@macs-frontend/core/utils/uuid';

import { ApiService } from '@macs-frontend/core/services/api.service';
import { APIResponse, UserNotification } from '@macs-frontend/features/shared';
import { ListsUrls } from '@macs-frontend/core/utils/consts';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationService extends ApiService {
  constructor(http: HttpClient) {
    super(http);
  }

  getUserNotificationList() {
    return this.http.get<APIResponse<UserNotification[]>>(
      `${this.API_PATH}/${ListsUrls.Notifications}/my`,
    );
  }

  markAsRead(notificationId: UUID) {
    return this.http.patch<APIResponse<UserNotification>>(
      `${this.API_PATH}/${ListsUrls.Notifications}/${notificationId}/set_read`,
      {},
    );
  }
}
